import _axios from 'axios'

const authStages = ['int', 'cons'].includes(process.env.REACT_APP_ENV?.toLowerCase())

export const axios = _axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: authStages,
})

export const setAxiosToken = token => {
  if (token) {
    axios.defaults.headers.common['x-auth-token'] = token
  } else {
    delete axios.defaults.headers.common['x-auth-token']
  }
}

export const setAxiosIdToken = id => {
  if (id) {
    axios.defaults.headers.common['x-id-token'] = id
  } else {
    delete axios.defaults.headers.common['x-id-token']
  }
}

export const getAxiosTokenFromQueryParam = () => {
  const queryParams = new URLSearchParams(window.location.search)
  return queryParams.get('token')
}

export const setAxiosTokenFromQueryParam = () => {
  const token = getAxiosTokenFromQueryParam()
  setAxiosToken(token)
}
